import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Container, Typography } from '@mui/material';
import Logo from '../components/logo';
import { ResetPassword } from '../sections/auth/login';
import { removeToken } from '../services/LocalStorageService';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '80vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));


export default function UserResetPassword() {
  removeToken();
  return (
    <>
      <Helmet>
        <title>DV Agent </title>
      </Helmet>
      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />
        <Container maxWidth="sm">
          <StyledContent>
            <ResetPassword/>
            <Typography color="text.secondary" sx={{ mb: 2, mt:5, fontSize: 18, fontWeight: 'bold' }}>
                Password Instructions-
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                1. &nbsp;Password should be alphanumeric.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                2. First letter of the password should be capital.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                3. Password length must be greater than 8 characters.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                4. Password should have any one of the special characters @, $, %, *.
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1, fontSize: 14 }}>
                5. Password field should not be empty.
            </Typography>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
